<template>
  <div
    style="background-color: #262d4a; font-family: Montserrat"
    class="layout--main"
    :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]"
  >
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
        />

        <div id="library-admin-view" class="router-view">
          <vx-card class="teacher__side-menu">
            <div v-for="(item, index) in sidebarItems" :key="index" class="w-full mb-3">
              <span class="pl-1 cursor-pointer flex" :class="[{'active-button': routeName == item.slug}, {'side-menu__button': routeName != item.slug}]" @click="navigate(item)">
                <feather-icon :icon="item.icon" svg-classes="stroke-current mr-2 pr-2"></feather-icon>
                <p class="ml-2">{{ item.name }}</p>
              </span>
            </div>
          </vx-card>
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="30" v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg back-to-top_btn"
                />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import TheNavbar from "@/digicampus/components/DigiNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "../components/libraryAdminSidebarItems.js";
import BackToTop from "vue-backtotop";

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "static",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeName: this.$route.name,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      windowWidth: window.innerWidth,
      hideScrollToTop: themeConfig.hideScrollToTop,
      activeLink: false,
      to: "",
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      this.routeName = this.$route.name;
    },
    isThemeDark(val) {
      if (val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    navigate(item) {
      var self = this;
      self.to = item.slug;
      self.$router.push({ name: item.slug });
    },
    updateTheme() {
      this.$setColors();
    },
  },
  components: {
    TheNavbar,
    TheFooter,
    BackToTop,
  },
  created() {
    document.title = "DigiCampus";
    this.setSidebarWidth();
    if (this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }

    this.$store.dispatch("updateTheme", "dark");

    this.$setSchoolTheme();
    this.updateTheme();
  },
};
</script>
<style lang="scss">
@import "../assets/FabStylesheet_1.scss";
@import "../assets/FabStylesheet_2.scss";
.vx-navbar-wrapper {
  background: none !important;
  padding: 2.2rem;
  padding-top: 1.3rem;
  z-index: 41000;
  height: 103px;
  position: relative;
  top: 0;
}
.vs-navbar.vx-navbar {
  background: linear-gradient(to bottom right, rgba(var(--vs-primary),1), rgba(var(--vs-secondary),1)) !important;
  padding: 0.8rem 1rem;
  width: calc(100% - 4.7rem);
  position: fixed;
  border-radius: 2.1rem;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  z-index: 10000;
}

#library-admin-view.router-view {
  padding: 0 !important;
  padding-left: 2.2rem !important;
  top: 0 !important;
  width: calc(100% - 3.2rem);

  .router-content {
    margin-top: 0 !important;
    text-align: -webkit-left !important;
    text-align: -moz-left !important;
    margin-left: 270px !important;

    .content-area__content {
      text-align: -webkit-center !important;
      text-align: -moz-center !important;
    }
  }
}

* {
  font-family: Montserrat;
}
</style>